import { Link } from 'react-router-dom';

const articles = [
  {
    id: 'santi-finale',
    title: '三体：大结局震撼上线，科幻迷不可错过',
    excerpt: '经过漫长的等待，备受瞩目的科幻巨制《三体》终于迎来大结局。本季以宏大的宇宙视角和深刻的人性探讨，为观众呈现了一场视觉与思想的双重盛宴...',
    category: '电视剧',
    date: '2024-12-28',
    readTime: '5分钟',
    imageUrl: 'https://readdy.ai/api/search-image?query=Sci-fi%20cosmic%20scene%20with%20distant%20stars%20and%20galaxies%2C%20mysterious%20dark%20space%20background%2C%20warm%20golden%20nebula%20accents%2C%20cinematic%20scale%2C%20atmospheric%20and%20awe-inspiring%2C%20clean%20composition&width=320&height=192&seq=news-1&orientation=landscape',
  },
  {
    id: 'spring-festival-2025',
    title: '2025春节档电影盘点：哪部值得看？',
    excerpt: '春节档作为全年最重要的电影档期之一，2025年春节档将有多部重量级影片上映。本文为您详细盘点即将上映的大片...',
    category: '电影',
    date: '2024-12-27',
    readTime: '8分钟',
    imageUrl: 'https://readdy.ai/api/search-image?query=Chinese%20new%20year%20celebration%20with%20red%20lanterns%20and%20golden%20decorations%2C%20festive%20cinema%20atmosphere%2C%20warm%20lighting%2C%20movie%20theater%20setting%2C%20cheerful%20mood%2C%20clean%20and%20elegant%20composition&width=320&height=192&seq=news-2&orientation=landscape',
  },
  {
    id: 'fanhua-phenomenon',
    title: '《繁花》为何成为年度现象级剧集？',
    excerpt: '由王家卫执导的《繁花》自播出以来，凭借独特的视觉风格和深刻的时代叙事，迅速成为现象级爆款。本文深度解析这部剧集的成功密码...',
    category: '电视剧',
    date: '2024-12-26',
    readTime: '6分钟',
    imageUrl: 'https://readdy.ai/api/search-image?query=Shanghai%20night%20scene%20with%20neon%20lights%2C%20vintage%20aesthetic%2C%20warm%20golden%20and%20amber%20tones%2C%20cinematic%20composition%2C%20stylish%20urban%20atmosphere%2C%20professional%20photography%20style&width=320&height=192&seq=news-3&orientation=landscape',
  },
  {
    id: 'guoman-2024',
    title: '国产动漫崛起：2024年度优秀国漫推荐',
    excerpt: '近年来国产动漫质量不断提升，涌现出越来越多优秀作品。2024年更是国漫大丰收的一年，本文为您精选年度最佳国漫作品...',
    category: '动漫',
    date: '2024-12-25',
    readTime: '7分钟',
    imageUrl: 'https://readdy.ai/api/search-image?query=Chinese%20animation%20style%20artwork%20with%20vibrant%20colors%2C%20ink%20wash%20painting%20influence%2C%20dynamic%20composition%2C%20warm%20and%20rich%20tones%2C%20artistic%20rendering%2C%20modern%20anime%20aesthetic%2C%20clean%20background&width=320&height=192&seq=news-4&orientation=landscape',
  },
];

export default function LatestContent() {
  return (
    <section className="bg-background-100 py-14 md:py-20">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="flex items-center justify-between mb-8">
          <div>
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">
              最新资讯
            </h2>
            <p className="text-sm text-foreground-600 mt-1">
              影视圈最新动态与深度解读
            </p>
          </div>
          <Link
            to="/category/movie"
            className="flex items-center gap-1 text-sm text-primary-500 hover:text-primary-600 font-medium no-underline whitespace-nowrap"
          >
            更多文章
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-5 md:gap-6">
          {articles.map((item) => (
            <Link
              key={item.id}
              to={`/article/${item.id}`}
              className="flex gap-4 p-4 rounded-xl bg-background-50 hover:bg-background-200/50 transition-colors no-underline group"
            >
              <div className="w-32 h-20 md:w-40 md:h-24 rounded-lg overflow-hidden flex-shrink-0 bg-background-200">
                <img
                  src={item.imageUrl}
                  alt={item.title}
                  title={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
              </div>
              <div className="flex-1 min-w-0 flex flex-col justify-between">
                <div>
                  <div className="flex items-center gap-2 mb-1 flex-wrap">
                    <span className="text-[10px] px-1.5 py-0.5 rounded bg-accent-100 text-accent-700 font-medium">
                      {item.category}
                    </span>
                    <span className="text-xs text-foreground-500">{item.date}</span>
                  </div>
                  <h3 className="text-sm md:text-base font-medium text-foreground-950 group-hover:text-primary-500 transition-colors line-clamp-2">
                    {item.title}
                  </h3>
                  <p className="text-xs text-foreground-500 mt-1 line-clamp-1 hidden sm:block">
                    {item.excerpt}
                  </p>
                </div>
                <div className="flex items-center gap-3 text-xs text-foreground-400 mt-2">
                  <span className="flex items-center gap-1">
                    <i className="ri-time-line"></i>
                    {item.readTime}
                  </span>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}